module.exports = {
          srcSet: __webpack_public_path__ + "9cc0eec4.jpg"+" 700w"+","+__webpack_public_path__ + "1a7a28d9.jpg"+" 1400w"+","+__webpack_public_path__ + "7beeae3e.jpg"+" 2048w",
          images:[ {path: __webpack_public_path__ + "9cc0eec4.jpg",width: 700,height: 467},{path: __webpack_public_path__ + "1a7a28d9.jpg",width: 1400,height: 934},{path: __webpack_public_path__ + "7beeae3e.jpg",width: 2048,height: 1366}],
          src: __webpack_public_path__ + "9cc0eec4.jpg",
          toString:function(){return __webpack_public_path__ + "9cc0eec4.jpg"},
          
          width: 700,
          height: 467
        }